/* eslint-disable arrow-parens */
/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
import { useState, forwardRef, useCallback, useContext, Suspense, useEffect } from "react";
import { MARITAL_STATUSES } from "../../../../../constants/maritalStatus";
import axios from "axios";
import { api } from "../../../../../utils/api";
import { LINK, port, url } from "../../../../../config/config";

import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import { ThemeContext } from "../../../../../contexts";
import { AuthContext } from "../../../../../contexts";
import GENDERS from "../../../../../constants/genders";
import { Grid, DialogContent, DialogActions, Slide, Button, Select, MenuItem } from "@mui/material";
import { CustomInput } from "../../../../shared/CustomInput";
import CustomSelectInput from "../../../../shared/CustomInput/CustomSelectInput";

import "date-fns";
import DateFnsUtils from "@date-io/date-fns";

import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import EventIcon from "@mui/icons-material/Event";

import "./profileEditDialog.css";
import { trackPromise } from "react-promise-tracker";
import initCapitalize from "../../../../../utils/commonFunctions/initCapitalize";

const Transition = forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

const ProfileEditDialog = ({ dialogProps, handleClose, member, setMember }) => {
	const { openDialog, actions } = dialogProps;
	const { theme } = useContext(ThemeContext);

	// const { member } = useContext(AuthContext);
	const [editProfile, setEditProfile] = useState({
		date_of_birth: "",
		gender: "",
		marital_status: ""
	});
	const [isEnrollment, setIsEnrollment] = useState(false);

	// const handleEditProfileChange = useCallback((event) => {
	// 	// console.log("Event", event.target.value);
	// }, []);
	// console.log(editProfile);
	// console.log("Member", member);

	const handleEditProfileChange = useCallback(
		(event) => {
			const { name, value } = event.target;
			setEditProfile(Object.assign({}, editProfile, { [name]: value }));
		},
		[editProfile]
	);

	// console.log("marital_status", editProfile);

	const handleDateChange = useCallback(
		(date, name) => {
			// console.log("Date", date);
			// console.log("Name", name);
			const _date = new Date(date);
			const parsedDate = _date.getFullYear() + "-" + (_date.getMonth() + 1) + "-" + _date.getDate();
			setEditProfile(Object.assign({}, editProfile, { [name]: parsedDate }));
		},
		[editProfile]
	);

	const handleEditProfileSubmitClick = useCallback(async () => {
		const payload = []; // empty array
		let _payload = {};

		if (isEnrollment && member) {
			if (editProfile.gender !== "") {
				const _gender = editProfile.gender.toUpperCase();
				_payload = {
					..._payload,
					gender: _gender
				};
			}
			if (editProfile.date_of_birth !== "") {
				_payload = {
					..._payload,
					date_of_birth: editProfile.date_of_birth
				};
			}
			if (editProfile.marital_status !== "") {
				_payload = {
					..._payload,
					marital_status: editProfile.marital_status
				};
			}
			const response = await api.editMemberDetails.editMemberDetailsChangeRequest(_payload, member.id);
			if (response) {
				setMember(Object.assign({}, response));
				alert("Edit Profile Details Successfull!");
				window.location.reload();
			}
		} else {
			if (editProfile.gender !== "") {
				const _gender = editProfile.gender.toUpperCase();
				const newPayload = {
					// group_number: member.group_number,
					previous_value: member.gender,
					change_value: _gender,
					operation_type: "UPDATE",
					field_name: "gender"
				};
				// console.log("Gender is defined");
				payload.push(newPayload); // new data pushed in new payload
				// console.log("After Gender payload", payload);
			}
			if (editProfile.marital_status !== "") {
				const newPayload = {
					// group_number: member.group_number,
					previous_value: member.marital_status,
					change_value: editProfile.marital_status,
					field_name: "marital_status",
					operation_type: "UPDATE"
				};
				// console.log("Marital status is defined");
				payload.push(newPayload);
				// console.log("After marital status payload", payload);
			}
			if (editProfile.date_of_birth !== "") {
				const newPayload = {
					// group_number: member.group_number,
					previous_value: member.date_of_birth,
					change_value: editProfile.date_of_birth,
					field_name: "date_of_birth",
					operation_type: "UPDATE"
				};
				// console.log("Date of birth is defined");
				payload.push(newPayload);
				// console.log("After date_of_birth", payload);
			}

			// ------------------------------------------------[SENDING DATA THROUGH AXIOS]-----------------------------------------------------------------

			const JWT_LOC = localStorage.getItem("@jwt_member");
			const POST_API = `${url}:${port}/api/v1/change-request/personal`;
			// console.log("Debug --- (PAYLOAD) --- ", payload);
			const SSN = member.SSN;
			const res = await trackPromise(
				axios.post(POST_API, payload, {
					headers: {
						Authorization: `Bearer ${JWT_LOC}`
					},
					params: {
						SSN: SSN
					}
				})
			);
			// console.log("RESPONSE -- (FROM AXIOS) ", res);

			if (res.status === 200) {
				alert("Request Sent Successfully");
			} else {
				return alert("Something went wrong");
			}
		}
		handleClose();
		// if (editProfile.gender !== "") {
		// 	const _gender = editProfile.gender.toUpperCase();
		// 	const newPayload = {
		// 		// group_number: member.group_number,
		// 		previous_value: member.gender,
		// 		change_value: _gender,
		// 		operation_type: "UPDATE",
		// 		field_name: "gender"
		// 	};
		// 	// console.log("Gender is defined");
		// 	payload.push(newPayload); // new data pushed in new payload
		// 	// console.log("After Gender payload", payload);
		// }
		// if (editProfile.marital_status !== "") {
		// 	const newPayload = {
		// 		// group_number: member.group_number,
		// 		previous_value: member.marital_status,
		// 		change_value: editProfile.marital_status,
		// 		field_name: "marital_status",
		// 		operation_type: "UPDATE"
		// 	};
		// 	// console.log("Marital status is defined");
		// 	payload.push(newPayload);
		// 	// console.log("After marital status payload", payload);
		// }
		// if (editProfile.date_of_birth !== "") {
		// 	const newPayload = {
		// 		// group_number: member.group_number,
		// 		previous_value: member.date_of_birth,
		// 		change_value: editProfile.date_of_birth,
		// 		field_name: "date_of_birth",
		// 		operation_type: "UPDATE"
		// 	};
		// 	// console.log("Date of birth is defined");
		// 	payload.push(newPayload);
		// 	// console.log("After date_of_birth", payload);
		// }

		// // ------------------------------------------------[SENDING DATA THROUGH AXIOS]-----------------------------------------------------------------

		// const JWT_LOC = localStorage.getItem("@jwt_member");
		// const POST_API = `${url}:${port}/api/v1/change-request/personal`;
		// // console.log("Debug --- (PAYLOAD) --- ", payload);
		// const SSN = member.SSN;
		// const res = await trackPromise(
		// 	axios.post(POST_API, payload, {
		// 		headers: {
		// 			Authorization: `Bearer ${JWT_LOC}`
		// 		},
		// 		params: {
		// 			SSN: SSN
		// 		}
		// 	})
		// );
		// // console.log("RESPONSE -- (FROM AXIOS) ", res);

		// if (res.status === 200) {
		// 	alert("Request Sent Successfully");
		// 	handleClose();
		// } else {
		// 	return alert("Something went wrong");
		// }
	}, [editProfile, handleClose, isEnrollment, member, setMember]);

	// console.log(member);

	const getEnrollmentGroupAndVEB = useCallback(async () => {
		const response = await trackPromise(api.enrollment.getEnrollmentGroupAndVEB());

		if (response) {
			const { openEnrollments, VEBOpenEnrollment } = response;
			// // console.log("openEnrollments", openEnrollments.length);
			// // console.log("VEBOpenEnrollment", VEBOpenEnrollment.length);

			if (openEnrollments.length != 0 || VEBOpenEnrollment != 0) {
				setIsEnrollment(true);
			} else {
				setIsEnrollment(false);
			}
		}
	}, []);

	useEffect(() => {
		getEnrollmentGroupAndVEB();
	}, [getEnrollmentGroupAndVEB]);

	return (
		<div>
			<Dialog
				style={{ zIndex: 800 }}
				open={openDialog}
				onClose={handleClose}
				TransitionComponent={Transition}
				keepMounted
				aria-labelledby="form-dialog-title"
				aria-describedby="alert-dialog-slide-description"
			>
				<DialogTitle className="title" style={{ color: theme.primary_color }}>
					{/* <div className="title" style={{ color: theme.primary_color }}> */}
					Edit Profile Information
				</DialogTitle>
				<DialogContent>
					<div className="profile-edit-dialog-container">
						<div className="profile-edit-form-each">
							<div className="profile-edit-form-label">Gender</div>
							<Suspense fallback={<div />}>
								<Select
									name="gender"
									input={<CustomSelectInput />}
									style={{ width: "55%" }}
									onChange={handleEditProfileChange}
								>
									{/* <MenuItem value={""}>
										<em>None</em>
									</MenuItem> */}
									{GENDERS.map((option, index) => {
										return (
											<MenuItem value={option} key={index} className="select-field-style">
												{initCapitalize(option)}
											</MenuItem>
										);
									})}
								</Select>
								{/* <CustomInput
									name="gender"
									value={editProfile.gender}
									onChange={handleEditProfileChange}
								/> */}
							</Suspense>
						</div>

						{member?.employee_SSN === member?.SSN ? (
							<div className="profile-edit-form-each">
								<div className="profile-edit-form-label">Marital Status</div>
								{/* <Suspense fallback={<div />}> */}
								<Select
									name="marital_status"
									input={<CustomSelectInput />}
									style={{ width: "55%" }}
									onChange={handleEditProfileChange}
								>
									{/* <MenuItem value={""}>
										<em>None</em>
									</MenuItem> */}
									{MARITAL_STATUSES.map((option, index) => {
										return (
											<MenuItem value={option} key={index} className="select-field-style">
												{initCapitalize(option)}
											</MenuItem>
										);
									})}
								</Select>
								{/* <CustomInput
									name="marital_status"
									value={editProfile.marital_status}
									onChange={handleEditProfileChange}
								/> */}
								{/* </Suspense> */}
							</div>
						) : null}
						<div className="profile-edit-form-each">
							<div className="profile-edit-form-label">Date of Birth</div>
							<Suspense fallback={<div />}>
								<MuiPickersUtilsProvider utils={DateFnsUtils}>
									<KeyboardDatePicker
										className=" edit-date-profile-picker"
										id="from-date-input"
										inputVariant="standard"
										placeholder={"Enter date of birth"}
										name={"date_of_birth"}
										format="MM/dd/yyyy"
										error={false}
										value={editProfile.date_of_birth}
										onChange={(_date) => handleDateChange(_date, "date_of_birth")}
										InputProps={{
											readOnly: true,
											disableUnderline: true
										}}
										InputLabelProps={{
											shrink: true
										}}
										style={{ width: "90%", borderRadius: 10, lineHeight: "1.4375em " }}
										keyboardIcon={<EventIcon style={{ color: "#7cb342" }} />}
										KeyboardButtonProps={{
											"aria-label": "change date"
										}}
										helperText={""}
									/>
								</MuiPickersUtilsProvider>
							</Suspense>
						</div>
					</div>
				</DialogContent>
				<DialogActions className="profile-edit-dialog-action-button-container">
					{actions?.map((action, index) => {
						const { label, callback } = action;
						return (
							<Button
								variant="contained"
								key={index}
								onClick={callback}
								className="profile-edit-dialog-action-button"
								style={{
									backgroundColor: theme.button.background_color,
									color: theme.button.color
								}}
							>
								{label}
							</Button>
						);
					})}
					<Button
						variant="contained"
						onClick={handleEditProfileSubmitClick}
						className="profile-edit-dialog-action-button"
						disabled={
							editProfile.date_of_birth === "" &&
								editProfile.gender === "" &&
								editProfile.marital_status === ""
								? true
								: false
						}
						style={{
							backgroundColor: theme.button.background_color,
							color: theme.button.color
						}}
					>
						{isEnrollment ? "Submit" : "Submit Request"}
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
};

export default ProfileEditDialog;
